import { useEffect } from 'react';
import { useDispatch } from 'state';
import timerActions from 'actions/timer';
import { useCommunicationService } from 'src/app/services/communication';
import { MessageType } from 'src/app/utils/in-app-comunication/types';

export const useTimerEnabledListener = () => {
  const dispatch = useDispatch();
  const comms = useCommunicationService();

  useEffect(() => {
    const unsubscribe = comms.onMessage((message) => {
      if (message.type === MessageType.TIMER_ENABLED_CHANGE && message.isTimerEnabled !== undefined) {
        dispatch(timerActions.setTimerEnabled(message.isTimerEnabled));
      }
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [comms, dispatch]);
};
